import { inject, Pipe, PipeTransform } from '@angular/core';
import { Dayjs } from 'dayjs';
import { DateTimeFormat, DateTimePipe } from './date-time.pipe'; // Adjust the import path as needed

@Pipe({ name: 'datePipe' })
export class DatePipe implements PipeTransform {
  private dateTimePipe = inject(DateTimePipe);

  transform(value?: Dayjs | Date | number | string): string {
    return this.dateTimePipe.transform(value, DateTimeFormat.DATE);
  }
}
